import { Box, Paper, useTheme } from "@mui/material";
import {
  authLogoStyles,
  authPageContainerStyles,
  authPaperStyles,
  authTitleStyles,
} from "../styles/commonStyles";
import logoGreen from "../assets/images/logo_smaart_green.png";
import ChangePasswordForm from "../components/forms/changePasswordForm.component";

const ResetPasswordPage = () => {
  const theme = useTheme();
  return (
    <Box sx={authPageContainerStyles(theme)}>
      <Paper sx={authPaperStyles}>
        <Box sx={authTitleStyles}>CAMBIO PASSWORD</Box>
        <Box
          component="img"
          src={logoGreen}
          alt="Smaart Logo"
          sx={authLogoStyles}
        />
        <ChangePasswordForm />
      </Paper>
    </Box>
  );
};

export default ResetPasswordPage;
